<!--
  户籍化页面模板单页
-->
<style lang="less" scoped>
  @import "~@/public/less/index.less";
  .f-plugin-single {
    width: 100%; height: 100% !important; overflow: hidden;
    .head {
      padding: 20px;
      font-size: 1.1em;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .head-title {
        flex: 1;
        cursor: pointer;
        &:hover { color: rgb(var(--primary-6)); }
      }

      .head-actions {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-shrink: 0;
        margin-left: 20px;
      }
    }
    /* 编辑模式切换 */
    .edit-body {
      height: 100%;
      overflow-y: auto;
      padding: 20px;
      background-color: var(--card-bg, #fff);
    }
  }
</style>
<template>
  <div class="fan fan-component f-plugin-single">
    <f-layout ref="flayout"
              v-if="superApi && superColumns"
              :superPage="page"
              :superApi="api"
              @reloadData="reloadData">
      <!-- 头部：标题 + 操作按钮 -->
      <template #head v-if="superTitle">
        <div class="head">
          <span class="head-title" @click="$fan.page.open(returnUrl.url, returnUrl.query)">
            {{superTitle || router.info.name}}
          </span>
          <div class="head-actions">
            <!-- 编辑模式切换 -->
            <a-button v-if="!editing"
                      type="primary"
                      size="small"
                      @click="bindStartEdit">
              <icon-edit /> 编辑
            </a-button>
            <template v-else>
              <a-button size="small" @click="bindCancelEdit">取消</a-button>
              <a-button type="primary" status="success" size="small" @click="bindSaveEdit">
                <icon-check /> 保存
              </a-button>
            </template>
          </div>
        </div>
      </template>

      <!-- 子菜单 -->
      <template #menus v-if="menus && Object.keys(menus).length>1 && !editing">
        <a-menu mode="inline"
                :style="{ height: '100%', borderRight: 0 }"
                :defaultOpenKeys="[`${router.topInfo.url}`]"
                :defaultSelectedKeys="[`${router.info.url}`]">
          <template v-for="(item, index) in menus">
            <a-sub-menu :key="index"
                        v-if="item.info.show &&
                              item.info.type==='menu' &&
                              item.info.level===(router.navInfo.level+1) &&
                              !item.info.hasTmp && item.info.hasChild">
              <template #title>
                <component :is="'icon-' + item.info.icon" />
                <span>{{item.info.name}}</span>
              </template>
              <template v-for="(item2, index2) in menus">
                <a-menu-item :key="index2"
                             v-if="item2.info.type==='menu' &&
                                   item2.topInfo.url===item.info.url &&
                                   item2.info.level===(router.navInfo.level+2)"
                             @click="$fan.page.open(index2, query)">
                    <span>
                      <component :is="'icon-' + item2.info.icon" />
                      <span>{{item2.info.name}}</span>
                    </span>
                </a-menu-item>
              </template>
            </a-sub-menu>
            <a-menu-item :key="'menu-' + index"
                         v-else-if="item.info.show &&
                                    item.info.level===(router.navInfo.level+1) &&
                                    item.info.hasTmp"
                         @click="$fan.page.open(index2, query)">
                  <span>
                    <component :is="'icon-' + item.info.icon" />
                    <span>{{item.info.name}}</span>
                  </span>
            </a-menu-item>
          </template>
        </a-menu>
      </template>

      <!-- 正文内容 -->
      <template #body>
        <!-- 查看模式 -->
        <f-detail v-if="!editing" ref="fdetail"
                  :superApi="superApi"
                  :superData="data" />
        <!-- 编辑模式 -->
        <div v-else class="edit-body">
          <f-form ref="fform"
                 :superApi="superApi"
                 :superData="data"
                 @emitOpenDrawer="bindOpenDrawer"
                 @emitCloseDrawer="bindCloseDrawer"
                 @emitReloadData="bindReloadData" />
        </div>
      </template>
    </f-layout>
  </div>
</template>

<script>
  import { IconEdit, IconCheck } from '@arco-design/web-vue/es/icon'

  export default {
    name: 'FPluginSingle',
    components: { IconEdit, IconCheck },
    props: {
      superTitle: String,
      superApi: String,
      superColumns: Array,
      superQuery: Array
    },
    created() {
      this.page = this.$fan.utils.parse(this.def.page)
      this.data = this.$fan.utils.parse(this.def.data)
    },
    async mounted() {
      await this.initPage()
    },
    async activated() {
      await this.initPage()
    },
    computed: {
      routers() {
        return this.$store.state.routers || {}
      },
      router() {
        return this.routers[this.$route.path] || {}
      },
      menus() {
        let menus = {}
        if (this.router && this.router.navInfo && this.router.navInfo.hasChild) {
          for (let k in this.routers) {
            const router = this.routers[k]
            let routerNavUrl = ""
            for (let i = 0; i < this.router.navInfo.level; i++) {
              routerNavUrl = routerNavUrl + "/" + router.info.path[i]
            }
            if (router.info.type !== 'nav' && routerNavUrl === this.router.navInfo.url) {
              menus[router.info.url] = router
            }
          }
        }
        return Object.keys(menus).length > 0 ? menus : false
      },
      query() {
        const q = this.$route.query
        return (q && this.$fan.utils.notEmpty(q)) ? q : false
      },
      api() {
        let api = this.superApi.split('?')
        if (this.superQuery && this.query) {
          let queryArr = []
          for (var k in this.query) {
            if (this.superQuery.indexOf(k) > -1) {
              queryArr.push(`${k}=${this.query[k]}`)
            }
          }
          let qs = queryArr.join('&')
          return api.length > 1 ? `${this.superApi}&${qs}` : `${this.superApi}?${qs}`
        }
        return this.superApi
      },
      returnUrl() {
        const breadcrumb = (this.router.info && this.router.info.breadcrumb) || []
        if (breadcrumb.length > 2) {
          let ret = { name: "首页", icon: "home", url: "/", query: {} }
          // 从后往前找第一个 hasTmp 的页面作为返回目标
          for (let i = breadcrumb.length - 2; i >= 0; i--) {
            const url = breadcrumb[i].url
            if (this.routers[url] && this.routers[url].info && this.routers[url].info.hasTmp) {
              ret = breadcrumb[i]
              break
            }
          }
          let retQuery = this.$fan.utils.parse(this.query)
          if (this.superQuery) {
            delete retQuery[this.superQuery]
          }
          ret.query = retQuery
          return ret
        }
        return { name: "首页", icon: "home", url: "/", query: {} }
      }
    },
    data() {
      return {
        editing: false,
        data: {},
        page: {},
        def: {
          data: {},
          page: {
            initing: false,
            loading: false,
            filter: {
              page: 1,
              limit: 1
            }
          }
        }
      }
    },
    methods: {
      async initPage() {
        this.page = this.$fan.utils.parse(this.def.page)
        if (this.superApi && this.superColumns) {
          if (this.superQuery) {
            if (this.query && Object.keys(this.query).length > 0) {
              this.reloadData()
            }
          } else {
            this.reloadData()
          }
        } else {
          this.$message.warning('页面模板未设置必要参数')
        }
      },
      async loadData() {
        this.page.loading = true
        try {
          const {data} = await this.$fan.api.get(this.api, this.page.filter)
          this.data = data.data ? data.data[0] : null
          this.$store.state.page.data = data
        } catch (e) {
          console.error('加载数据失败:', e)
          this.$message.error('数据加载失败')
        }
        this.page.loading = false
      },

      async reloadData() {
        this.page.initing = true
        this.page.filter = this.$fan.utils.parse(this.def.page.filter)
        await this.loadData()
        await this.$fan.page.loadCallback(this.superColumns, this.data)
        this.page.initing = false
      },

      /* ========== 编辑相关 ========== */
      bindStartEdit() {
        this.editing = true
        this.$nextTick(() => {
          if (this.$refs.fform) {
            this.$refs.fform.reloadData && this.$refs.fform.reloadData()
          }
        })
      },

      async bindSaveEdit() {
        if (!this.$refs.fform) return
        try {
          await this.$refs.fform.actionFormSubmit()
          this.editing = false
        } catch (e) {
          console.error('保存失败:', e)
        }
      },

      bindCancelEdit() {
        this.editing = false
        this.reloadData()
      },

      /* ========== 回调转发（给 FForm 使用） ========== */
      bindOpenDrawer(title, record) {
        this.$refs.flayout.bindOpenCurd(title, record)
      },
      bindCloseDrawer() {
        this.$refs.flayout.bindCloseDrawer()
      },
      bindReloadData() {
        this.$refs.flayout.bindReloadData()
      }
    }
  }
</script>
